import { render, staticRenderFns } from "./Update-User-Phone.vue?vue&type=template&id=360dda3c&scoped=true&"
import script from "./Update-User-Phone.vue?vue&type=script&lang=js&"
export * from "./Update-User-Phone.vue?vue&type=script&lang=js&"
import style0 from "./Update-User-Phone.vue?vue&type=style&index=0&id=360dda3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360dda3c",
  null
  
)

export default component.exports